import React, { useContext, useRef, useEffect } from "react";
import { PlateElement, type PlateElementProps } from "platejs/react";
import type { LogBlockElement } from "../schema";
import { LogCard } from "../../LogCard";
import { useTags } from "../../../../common/contexts/TagsContext";
import { useProjects } from "../../../../common/contexts/ProjectContext";
import { CortesEditorContext, nodeText } from "../schema";

export function LogBlock(props: PlateElementProps) {
  const el = props.element as LogBlockElement & Record<string, any>;
  const { getCameraName, getTagColor, getTagLabel, directors } = useTags();
  const { participantList: participants } = useProjects();
  const ctx = useContext(CortesEditorContext);
  const isHighlighted = (el.tcIn || el.tc) === ctx?.activeMockTc;
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const div = containerRef.current;
    if (!div) return;
    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      // Evitar que dispare reproducción si clickea botones o controles internos
      if (
        target.closest("button") ||
        target.closest("a") ||
        target.closest("[data-log-editing]") ||
        target.closest('[title="Eliminar"]') ||
        target.closest('[title="Editar"]') ||
        target.closest('[title="Ver Metadatos"]') ||
        target.closest('[title="Ocultar Metadatos"]')
      ) {
        return;
      }
      if (ctx?.onTimecodeClick) {
        ctx.onTimecodeClick(el);
      }
    };
    div.addEventListener("click", handleClick);
    return () => {
      div.removeEventListener("click", handleClick);
    };
  }, [el, ctx?.onTimecodeClick]);

  return (
    <PlateElement {...props} style={{ margin: "8px 0" }}>
      <div
        ref={containerRef}
        id={`cortes-item-${el.sourceId || el.id}`}
        style={{
          cursor: "pointer",
          transition: "all 0.2s ease",
          borderRadius: "8px",
          background: isHighlighted ? "rgba(255, 220, 0, 0.03)" : "transparent",
          padding: isHighlighted ? "4px" : "0",
          transform: isHighlighted ? "scale(1.01)" : "scale(1)",
        }}
      >
        <LogCard
          log={{ ...el, type: "log", text: nodeText(el), id: el.sourceId || el.id }}
          participants={participants}
          directors={directors}
          accentColor="var(--color-role-sp)"
          getCameraName={getCameraName}
          getTagColor={getTagColor}
          getTagLabel={getTagLabel}
          isAssembly={true}
          isHighlighted={isHighlighted}
          blockEditorText={props.children}
        />
      </div>
    </PlateElement>
  );
}
